import { GroupedType } from '../controls/grid/GroupedType';
import { IGroupedItem } from '../controls/grid/IGroupedItem';
import { SearchTerm } from './SearchTerm';

export class SearchTermGroupedItem extends SearchTerm implements IGroupedItem {
    public _class: string;
    public value: string;
    public type: GroupedType;

    public collectionId: string;
    public resourceId: string;

    constructor(searchTerm: SearchTerm, type: GroupedType, collectionId: string, resourceId: string) {
      super(searchTerm.id, searchTerm.projectId, searchTerm.searchTermListId, searchTerm.term, searchTerm.isValid);
      this._class = 'SearchTermGroupedItem';
      this.value = searchTerm.term;
      this.type = type;
      this.collectionId = collectionId;
      this.resourceId = resourceId;
    }
}
